import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { transparentize } from "polished";
var sizes = {
    small: 16,
    medium: 24,
    large: 32
};
var Button = /*#__PURE__*/ styled("button", {
    target: "e19auz8k0"
})("display:inline-flex;flex-shrink:0;margin:0;padding:0;border:0;outline:0;width:", function(param) {
    var size = param.size;
    return "".concat(sizes[size], "px");
}, ";height:", function(param) {
    var size = param.size;
    return "".concat(sizes[size], "px");
}, ";text-decoration:underline;color:inherit;background:none;fill:currentcolor;cursor:pointer;");
var IconBackground = /*#__PURE__*/ styled("div", {
    target: "e19auz8k1"
})("border-radius:50%;display:flex;padding:4px;margin:-4px;", function(param) {
    var selected = param.selected, theme = param.theme;
    return css(_templateObject(), selected && transparentize(0.8, theme.color.primary || "#FFFFFF"));
}, ";");
export { Button, IconBackground };
